import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';
import { useMobileConfig } from '../../hooks/useMobileConfig';

const MobileMenuOverlay = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isScreenVisible } = useMobileConfig();

  const navigationItems = {
    operations: [
      { path: '/dashboard', label: 'Dashboard', icon: 'LayoutDashboard', screenKey: 'dashboard' },
      { path: '/customer-management', label: 'Customers', icon: 'Users', screenKey: 'customer_management' },
      { path: '/bid-management', label: 'Bids', icon: 'FileText', screenKey: 'bid_management' },
      { path: '/project-management', label: 'Projects', icon: 'Briefcase', screenKey: 'project_management' },
      { path: '/project-phases', label: 'Phases', icon: 'GitBranch', screenKey: 'project_phases' },
      { path: '/resource-management', label: 'Resources', icon: 'Package', screenKey: 'resource_management' },
      { path: '/prospect-management', label: 'Prospects', icon: 'Target', screenKey: 'prospect_management' },
      { path: '/pm-dashboard', label: 'PM Dashboard', icon: 'LayoutDashboard', screenKey: 'pm_dashboard' },
    ],
    analytics: [
      { path: '/analytics', label: 'Analytics & Reporting', icon: 'BarChart3', screenKey: 'analytics' }
    ],
    admin: [
      { path: '/team-administration', label: 'Site Administration', icon: 'Settings2', screenKey: 'team_administration' },
      { path: '/audit-log', label: 'Audit Log', icon: 'ClipboardList', screenKey: 'audit_log' },
      { path: '/application-bug-tracker', label: 'Bug Tracker', icon: 'Bug', screenKey: 'application_bug_tracker' },
    ],
    profile: [
      { path: '/profile', label: 'Profile', icon: 'User', screenKey: null }
    ]
  };

  const isActive = (path) => location?.pathname === path;

  const handleNavigation = (path) => {
    navigate(path);
    onClose();
  };

  const filterVisible = (items) => items?.filter(item => item?.screenKey === null || isScreenVisible(item?.screenKey));

  if (!isOpen) return null;

  const visibleOperations = filterVisible(navigationItems?.operations);
  const visibleAnalytics = filterVisible(navigationItems?.analytics);
  const visibleAdmin = filterVisible(navigationItems?.admin);
  const visibleProfile = filterVisible(navigationItems?.profile);

  return (
    <div className="mobile-menu-overlay">
      <div className="mobile-menu-header">
        <div className="flex items-center gap-3">
          <div className="primary-nav-logo">
            <Icon name="HardHat" size={24} color="#FFFFFF" />
          </div>
          <span className="primary-nav-title">ConstructionPro</span>
        </div>
        <Button variant="ghost" size="icon" onClick={onClose}>
          <Icon name="X" size={24} />
        </Button>
      </div>
      <div className="mobile-menu-content">
        {visibleOperations?.length > 0 && (
          <div className="mobile-menu-section">
            <h3 className="mobile-menu-section-title">Operations</h3>
            {visibleOperations?.map((item) => (
              <button
                key={item?.path}
                onClick={() => handleNavigation(item?.path)}
                className={`mobile-menu-item ${isActive(item?.path) ? 'active' : ''}`}
              >
                <Icon name={item?.icon} size={20} />
                <span>{item?.label}</span>
              </button>
            ))}
          </div>
        )}

        {visibleAnalytics?.length > 0 && (
          <div className="mobile-menu-section">
            <h3 className="mobile-menu-section-title">Analytics</h3>
            {visibleAnalytics?.map((item) => (
              <button
                key={item?.path}
                onClick={() => handleNavigation(item?.path)}
                className={`mobile-menu-item ${isActive(item?.path) ? 'active' : ''}`}
              >
                <Icon name={item?.icon} size={20} />
                <span>{item?.label}</span>
              </button>
            ))}
          </div>
        )}

        {visibleAdmin?.length > 0 && (
          <div className="mobile-menu-section">
            <h3 className="mobile-menu-section-title">Admin</h3>
            {visibleAdmin?.map((item) => (
              <button
                key={item?.path}
                onClick={() => handleNavigation(item?.path)}
                className={`mobile-menu-item ${isActive(item?.path) ? 'active' : ''}`}
              >
                <Icon name={item?.icon} size={20} />
                <span>{item?.label}</span>
              </button>
            ))}
          </div>
        )}

        {visibleProfile?.length > 0 && (
          <div className="mobile-menu-section">
            <h3 className="mobile-menu-section-title">Account</h3>
            {visibleProfile?.map((item) => (
              <button
                key={item?.path}
                onClick={() => handleNavigation(item?.path)}
                className={`mobile-menu-item ${isActive(item?.path) ? 'active' : ''}`}
              >
                <Icon name={item?.icon} size={20} />
                <span>{item?.label}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MobileMenuOverlay;